import { truncatedEllipsizedTextCSS } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 100%;
`;

export const MapContainer = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
`;

export const SearchThisAreaContainer = styled.div<{ showSearchAreaButton: boolean }>`
  position: absolute;
  top: ${props => props.theme.space.s10};
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: white !important;
  height: 3.2rem;
  width: 15.2rem;
  color: ${props => props.theme.colors.capsuleGreen60};
  justify-content: center;
  border-radius: 0.3rem;
  border: 1px solid ${props => props.theme.colors.capsuleGreen00};
  display: ${props => (props.showSearchAreaButton ? 'flex' : 'none')};
`;

export const MapDetailBox = styled.div`
  position: absolute;
  top: ${props => props.theme.space.s5};
  background-color: white;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 4;
  width: ${({ theme }) => `calc(100% - ${theme.space.s5} - ${theme.space.s5})`};
  display: flex;
  flex-wrap: nowrap;
`;

export const MapDetailImage = styled.div<{ imageSrc: string }>`
  width: 7rem;
  min-height: 100%;
  flex: none;
  background-image: ${props => `url(${props.imageSrc})`};
  background-color: ${props => props.theme.colors.capsuleGreen00};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 5;
`;

export const MapDetailTextContainer = styled.div`
  height: 100%;
  z-index: 5;
  padding: ${props => props.theme.space.s4} ${props => props.theme.space.s5};

  ${truncatedEllipsizedTextCSS}
  & > p {
    ${truncatedEllipsizedTextCSS}
  }
`;
